module.exports = {
      id: "share-telegram-usage",
      viewBox: "0 0 42 42",
      url: __webpack_public_path__ + "svg-sprite-f2ca7f9d4080f6eed262da64a41d98e9.svg#share-telegram",
      toString: function () {
        return this.url;
      }
    }